import {Colors} from '@eitje/assets'
import {Layout, Text, Icon} from '~/components'

export const LegendBody = ({items}) => {
	return (
		<Layout className="popout-legend-body" direction="vertical">
			{items.map(item => (
				<LegendItem key={item.color} {...item} />
			))}
		</Layout>
	)
}

const LegendItem = ({color, t}) => {
	return (
		<Layout direction="horizontal" padding="10 16" gap="16" borderBottom>
			<Icon name="dot" size={16} fill={Colors[color]} />
			<Text t={t} truncate />
		</Layout>
	)
}
